// hooks/useAuth.js
import { useState, useEffect } from 'react';

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('token');
      
      // Option simple : présence du token
      if (token) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }

      // Version plus stricte (vérifie que le token n'est pas expiré)
      // if (token) {
      //   try {
      //     const payload = JSON.parse(atob(token.split('.')[1]));
      //     const exp = payload.exp * 1000; // en ms
      //     if (Date.now() >= exp) {
      //       localStorage.removeItem('token');
      //       setIsAuthenticated(false);
      //     } else {
      //       setIsAuthenticated(true);
      //     }
      //   } catch (e) {
      //     localStorage.removeItem('token');
      //     setIsAuthenticated(false);
      //   }
      // } else {
      //   setIsAuthenticated(false);
      // }

      setIsLoading(false);
    };

    checkAuth();

    // Optionnel : réécouter le storage (utile si plusieurs onglets)
    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    // localStorage.removeItem('userID'); // si tu gardes encore ça temporairement
    setIsAuthenticated(false);
    // window.location.href = '/login'; // ou utiliser useNavigate
  };

  return { isAuthenticated, isLoading, logout };
}